module.exports = __webpack_public_path__ + "c781438d9c4a867b93c50cf1659f901e.svg";